export const createAbortError = () => {
    try {
        return new DOMException('', 'AbortError');
    }
    catch (err) {
        // Bug #122: Edge is the only browser that does not yet allow to construct a DOMException.
        err.code = 20;
        err.name = 'AbortError';
        return err;
    }
};
//# sourceMappingURL=/build/es2018/factories/abort-error.js.map